<template>
    <div class="page preloader">
        
        
        <img :src="getStaticImage('logo.png')" alt="">
        <Loader></Loader>
    
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import Loader from "./Loader";
    
    
    export default {
        name: "Preloader",
        components: {Loader},
        computed: {
            ...mapState("shared", ["settings","preloaded"])
        },
        created() {
            if(!Object.entries(this.preloaded).length){
                this.$store.dispatch("shared/getData");
            }
            //console.log(JSON.parse(window.localStorage.getItem("liked")));
            const liked = window.localStorage.getItem("liked");
            if(liked){
                this.$store.commit( "recipe/setLiked", JSON.parse( liked ) );
            }
            const recentSearch = window.localStorage.getItem("recentSearch");
            if(recentSearch){
                this.$store.commit( "app_search/setRecentSearch", JSON.parse( recentSearch ) );
            }
            
        }
    }
</script>
